import { palette } from '@livable/saas-react-components';
const MuiSwitch = {
  styleOverrides: {
    track: {
      backgroundColor: palette.shades[400],
      opacity: '1'
    },
    thumb: {
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.25), 0px 0px 1px rgba(0, 0, 0, 0.25)'
    },
    switchBase: {
      '&.Mui-checked': {
        color: palette.shades[100],
        '.MuiSwitch-thumb': {
          boxShadow: '0px 0px 1px 0px #00000040, 0px 1px 2px 0px #00000040, 0px 1px 4px 0px #00000040'
        },
        '+.MuiSwitch-track': {
          opacity: '1'
        }
      },
      '&.Mui-disabled': {
        '+.MuiSwitch-track': {
          opacity: '1'
        }
      }
    }
  }
};
export default MuiSwitch;